<template lang="pug">
  .cart-promo-item
    button.remove.btn-reset.icon-x-full.color-font-subtle.xs-f-small.max-at-tweak(v-if="promo.can_remove" @click="openRemovePromoModal({promoId: promo.id})")
      span.ada-tooltip remove promotion {{promo.displayName}}
    
    p.top-label.upper.xs-f-xsmall.max-at-tweak(data-mr-ass="discounts")
      span.display-name.upper.xs-f-xsmall.max-at-tweak(:class="{wide: showOffers}" data-mr-ass="discount-name") {{promo.displayName}}
      span.display-amount.float-right.semi-bold.xs-f-xsmall.max-at-tweak(v-if="!showOffers && promo.displayAmount && !freeShippingPromo && !hideOriginalPrice" data-mr-ass="discount-amount") &nbsp;-{{promo.displayAmount | currency}}
    
    ul.xs-f-xsmall.max-at-tweak(v-if="showOffers")
      li.offer.upper.xs-f-xsmall.max-at-tweak(v-for="offer in promo.offers")
        span.display-name.upper.xs-f-xsmall.max-at-tweak {{offer.display_name}}
        span.display-amount.float-right.semi-bold.xs-f-xsmall.max-at-tweak(v-if="offer.displayAmount && !freeShippingOffer(offer) && offer.showOriginalPrice") -{{offer.displayAmount | currency}}
  
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "CartPromoItem",

    props: {
      promo: Object
    },

    computed: {
      // returns true if promo has one offer and that offer is free shipping
      freeShippingPromo() {
        return this.promo && this.promo.offers && this.promo.offers.length == 1 && this.promo.offers[0].type == "freeShipping";
      },

      // returns true if promo has one offer and that offer has showOriginalPrice == 0
      hideOriginalPrice() {
        return this.promo && this.promo.offers && this.promo.offers.length == 1 && this.promo.offers[0].showOriginalPrice == 0;
      },

      showOffers() {
        if (this.promo && this.promo.offers && this.promo.offers.length > 1) {
          return true;
        }
      }
    },

    methods: {
      ...mapActions('cart', ['openRemovePromoModal']),

      freeShippingOffer(offer) {
        return offer.type == "freeShipping";
      }
    }
   }
</script>

<style scoped lang="stylus">
  .cart-promo-item
    position relative
    padding-bottom 1.5em
    
    .top-label
      padding-left 1.75em
      
    .remove
      position absolute
      top -0.1em
      left 0
      
    .display-name
    .display-amount
      display inline-block
      
    .display-name
      max-width 12em
      
      &.wide
        max-width 16em
    
    .offer
      padding-left 1.75em
      
</style>
